// Generated by ReScript, PLEASE EDIT WITH CARE


function opacity(valOpt) {
  var val = valOpt !== undefined ? valOpt : 0.2;
  return {
          NAME: "Opacity",
          VAL: val
        };
}

function highlight(backgroundColor, opacityOpt) {
  var opacity = opacityOpt !== undefined ? opacityOpt : 0.85;
  return {
          NAME: "Highlight",
          VAL: {
            backgroundColor: backgroundColor,
            opacity: opacity
          }
        };
}

function toVariant(t) {
  return t;
}

export {
  opacity ,
  highlight ,
  toVariant ,
}
/* No side effect */
